<template>
  <div class="spl-report-edit-action-bar">
    <form-button
      style="grid-column: 1"
      @onClick="handleCancel">
      Cancel
    </form-button>
    <div style="grid-column: 2" />
    <form-button
      style="grid-column: 3"
      data-cy="report-edit-next"
      @onClick="handleNext">
      {{ nextLabel }}
    </form-button>
  </div>
</template>

<script>
export default {
  name: 'ReportActionBar',
  props: ['activeTab'],
  data () {
    return {
      nextLabel: 'Next'
    }
  },
  watch: {
    activeTab (value) {
      if (value === 'defaultFilter') {
        this.nextLabel = 'Save'
      } else {
        this.nextLabel = 'Next'
      }
    }
  },
  mounted () {
  },
  methods: {
    handleCancel () {
      this.$emit('onCancel')
    },
    handleNext () {
      this.$emit('onNext')
    }
  }
}
</script>

<style lang="scss">
    @import '../../../variables.scss';

    .spl-report-edit-action-bar {
        background-color: $yellowButtonLabelHover;
        bottom: 0;
        height: 70px;
        padding: 15px $mainPadding;
        position: fixed;
        display: grid;
        grid-template-columns: 150px auto 150px;
        width: 100%;

        .spl-label {
            color: $darkerYellow;
        }
        .spl-input {
            width: 450px;
        }
        .col3 {
            .spl-button {
                background-color: $footerButtonYellow;
                color: $yellowButtonLabel;
                margin: 0 2px 0 0;
                padding: 0 10px;
            }
        }
        .col2 {
            .spl-button {
                background-color: $mainInputColor;
                color: $footerButtonDarkGreyText;
                float: right;
            }
        }
    }
</style>
